import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nContext";
import { BrandProvider } from "@/context/BrandContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { BottomNav } from "@/components/BottomNav";
import { ScrollToTop } from "@/components/ScrollToTop";
import { PushManager } from "@/components/PushManager";
import { PushReminder } from "@/components/PushReminder";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ListingDetail from "@/pages/ListingDetail";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Register from "@/pages/Register";
import SellerDashboard from "@/pages/dashboard/SellerDashboard";
import BuyerDashboard from "@/pages/dashboard/BuyerDashboard";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";
import Messages from "@/pages/Messages";
import Offers from "@/pages/Offers";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import BuyerRequests from "@/pages/BuyerRequests";
import SellerRequests from "@/pages/SellerRequests";
import SellerProfile from "@/pages/SellerProfile";
import Profile from "@/pages/Profile";
import MyProgress from "@/pages/MyProgress";
import PublishListing from "@/pages/PublishListing";
import MonEspace from "@/pages/MonEspace";
import Parametres from "@/pages/Parametres";

function App() {
  return (
    <I18nProvider>
      <BrandProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <PushManager />
            <div className="min-h-screen flex flex-col bg-background">
              <Header />
              <main className="flex-1 pb-24 md:pb-0">
                <ErrorBoundary>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/catalogue" element={<Catalog />} />
                  <Route path="/volaille/:id" element={<ListingDetail />} />
                  <Route path="/profil-vendeur/:id" element={<SellerProfile />} />
                  <Route path="/connexion" element={<Login />} />
                  <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
                  <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
                  <Route path="/inscription" element={<Register />} />
                  <Route path="/vendeur" element={<ProtectedRoute roles={["seller"]}><SellerDashboard /></ProtectedRoute>} />
                  <Route path="/publier" element={<ProtectedRoute roles={["seller"]}><PublishListing /></ProtectedRoute>} />
                  <Route path="/mon-espace" element={<ProtectedRoute roles={["buyer", "seller"]}><MonEspace /></ProtectedRoute>} />
                  <Route path="/parametres" element={<ProtectedRoute roles={["buyer", "seller"]}><Parametres /></ProtectedRoute>} />
                  <Route path="/vendeur/commandes" element={<ProtectedRoute roles={["seller"]}><Orders /></ProtectedRoute>} />
                  <Route path="/vendeur/demandes" element={<ProtectedRoute roles={["seller"]}><SellerRequests /></ProtectedRoute>} />
                  <Route path="/acheteur" element={<ProtectedRoute roles={["buyer"]}><BuyerDashboard /></ProtectedRoute>} />
                  <Route path="/acheteur/commandes" element={<ProtectedRoute roles={["buyer"]}><Orders /></ProtectedRoute>} />
                  <Route path="/acheteur/demandes" element={<ProtectedRoute roles={["buyer"]}><BuyerRequests /></ProtectedRoute>} />
                  <Route path="/commande/:id" element={<ProtectedRoute roles={["buyer", "seller"]}><OrderDetail /></ProtectedRoute>} />
                  <Route path="/offres" element={<ProtectedRoute roles={["buyer", "seller"]}><Offers /></ProtectedRoute>} />
                  <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
                  <Route path="/echanges" element={<ProtectedRoute roles={["buyer", "seller"]}><Messages /></ProtectedRoute>} />
                  <Route path="/mon-evolution" element={<ProtectedRoute roles={["buyer", "seller"]}><MyProgress /></ProtectedRoute>} />
                  <Route path="/profil" element={<ProtectedRoute roles={["buyer", "seller", "admin"]}><Profile /></ProtectedRoute>} />
                </Routes>
                </ErrorBoundary>
              </main>
              <Footer />
            </div>
            <BottomNav />
            <PushReminder />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </BrandProvider>
    </I18nProvider>
  );
}

export default App;
